import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import Content from '../../../layout/Content';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { DELIVERY_POSTAL_CODE_PRICE_PATH } from '../../../../config/paths';
import Loader from '../../../common/Loader';

import NoDataResource from '../../../common/resource/NoDataResource';
import DeliveryPostalCodeBasicInformationResource from './DeliveryPostalCodeBasicInformationResource';
import {
  clearDeliveryPostalCodePrice,
  getDeliveryPostalCodePrice,
} from '../../../../actions/cargo/DeliveryPostalCodePrice';

const DeliveryPostalCodePrice = ({
  breadcrumbs,
  loading,
  match: {
    params: { id: deliveryPostalCodePriceId },
  },
  dispatchGetDeliveryPostalCodePrice,
  dispatchClearDeliveryPostalCodePrice,
  deliveryPostalCodePrice,
}) => {
  useLayoutEffect(() => {
    dispatchGetDeliveryPostalCodePrice({ deliveryPostalCodePriceId });
    return () => dispatchClearDeliveryPostalCodePrice();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (deliveryPostalCodePrice.isEmpty())
    content = <NoDataResource returnPage={DELIVERY_POSTAL_CODE_PRICE_PATH} />;
  else {
    const deliveryPostalCodePriceJson = deliveryPostalCodePrice.toJS();
    content = (
      <DeliveryPostalCodeBasicInformationResource
        {...deliveryPostalCodePriceJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Tarifario de Reparto por Código Postal"
      content={content}
    />
  );
};

DeliveryPostalCodePrice.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetDeliveryPostalCodePrice: PropTypes.func.isRequired,
  dispatchClearDeliveryPostalCodePrice: PropTypes.func.isRequired,
  deliveryPostalCodePrice: PropTypes.instanceOf(Immutable.Map).isRequired,
};

DeliveryPostalCodePrice.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDeliveryPostalCodePrice: clearDeliveryPostalCodePrice,
  dispatchGetDeliveryPostalCodePrice: getDeliveryPostalCodePrice,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tarifarios de Reparto por Código Postal',
      href: DELIVERY_POSTAL_CODE_PRICE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  deliveryPostalCodePrice: CargoUnit.DeliveryPostalCodePrice.getIn([
    'current',
    'content',
  ]),
  loading: !CargoUnit.DeliveryPostalCodePrice.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliveryPostalCodePrice);
